export const toCountryCode = (country) => ({
    "USA": "US",
    "Canada": "CA",
}[country] ?? country);
